import React, { useRef, Fragment } from 'react';
import { useReactToPrint } from 'react-to-print';

import PrintPreview from './PrintPreview';

const Print = (props) => {
  const ref = useRef();
  const { title, form, options } = props;

  const handlePrint = useReactToPrint({
    contentRef: ref,
    onBeforePrint: () => {
      document.title = title;
    },
  });

  return (
    <Fragment>
      <span style={{ width: '100%' }} onClick={handlePrint}>Print</span>
      <PrintPreview ref={ref} form={form} options={options} title={title} />
    </Fragment>
  );
};

export default Print;
